<template>
  <div class="frame">
    <div class="container">
      <div class="row">
        <div class="col">
          <hr />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Divider"
};
</script>
